<template>
    <!-- 短信分享 -->
    <el-main class="box">
        <div class="message_share" v-if="activeShare == 1">
            <div class="message_title">
                <span class="message_text">{{$t('PublishProject.SMSSharing')}}</span>
                <span class="view_share" style=" cursor: pointer;" @click="viewShareMessage()">{{$t('PublishProject.ViewSentTextMessages')}}</span>
            </div>
            <el-card shadow="never" :body-style="{ padding: '0' }" class="stepsbg">
                <el-steps :active="active" style="width: 920px; margin-left: 40px; padding-top: 35px">
                    <el-step :title="$t('PublishProject.AddRecipient')"></el-step>
                    <el-step :title="$t('PublishProject.EditContent')"></el-step>
                    <el-step :title="$t('PublishProject.Sent')"></el-step>
                </el-steps>
                <div v-if="active == 0" style="width: 920px; margin: 0 auto">
                    <p class="brief_introduction">
                        {{$t('PublishProject.BriefIntroduction')}}
                    </p>
                    <div class="Contact_table">
                        <el-card shadow="never" :body-style="{ padding: '0' }">
                            <div class="setContact">
                                <span>{{$t('PublishProject.ContactList')}}</span>
                                <i class="el-icon-setting setBtn" title="管理联系人" @click="setContact()"></i>
                            </div>
                            <div class="searchInput">
                                <el-input size="small" :placeholder="$t('PublishProject.InputContent')" prefix-icon="el-icon-search" v-model="input2" @input="searchInput()"></el-input>
                            </div>
                            <div class="treeBox" v-if="input2.length == 0">
                                <el-tree :data="options1" :props="props">
                                    <span class="custom-tree-node" slot-scope="{ node, data }">
                                        <span>
                                            {{ data.name }}
                                            <span v-if="data.contacts">{{ '(' + data.contacts.length + ')' }}</span>
                                        </span>
                                        <span class="btn" @click="addright(data)">引用</span>
                                    </span>
                                </el-tree>
                            </div>
                            <div v-else-if="input2.length > 0" class="treeBox2-box">
                                <div v-for="(item, index) in searchTell" :key="index" class="treeBox2">
                                    <span class="treeBox2-title" :title="item.name">{{ item.name }}</span>
                                    <el-button type="text" @click="treeBox2_a(index)">{{$t('PublishProject.Add')}}</el-button>
                                </div>
                            </div>
                        </el-card>
                        <el-card shadow="never" :body-style="{ padding: '0' }">
                            <div class="delContact">
                                <span>{{$t('PublishProject.ManuallyEnteringContacts')}}</span>
                                <el-button type="text" @click="delContact()">清空</el-button>
                            </div>
                            <!--短信联系人-->
                            <div class="MailCon_lxr-box">
                                <div
                                    id="MailCon_lxr"
                                    v-for="(item, index) in array"
                                    :key="index"
                                    style="
                                        margin-left: 10px;
                                        margin-top: 10px;
                                        color: #666;
                                        font-size: 14px;
                                    "
                                    :class="item.text_error ? '' : 'text_error'"
                                >
                                    <span style="display: flex;justify-content: space-between;align-items: center;">
                                        {{ item.cellphone }} &nbsp;, &nbsp;{{ item.name }}
                                        <i class="el-icon-delete right" style="margin-right: 15px; color: #0080ff;cursor: pointer;" @click="delMailConlxr(index)"></i>
                                    </span>
                                </div>
                                <div id="MailCon_srk" class="MailCon_srk" contenteditable="ture" @keyup.enter="addMailCon()"></div>
                            </div>
                        </el-card>
                    </div>
                    <div style="width: 646px; margin-left: 273px; margin-bottom: 20px;">
                        <div
                            style="
                                margin-top: 10px;
                                display: flex;
                                justify-content: space-between;
                                font-size: 14px;
                                align-items: center;
                            "
                        >
                            <span v-if="lenth > 0">{{$t('PublishProject.NumberOfRecipients')}} : {{ lenth }}</span>
                            <span v-else>{{$t('PublishProject.NumberOfRecipients')}} : 0</span>
                            <el-button size="small" style="display: inline-block" type="primary" :disabled="msgListErr" @click="xiaPart()">{{$t('PublishProject.NextStep')}}</el-button>
                        </div>
                    </div>
                </div>
                <!-- 编辑内容 -->
                <div v-if="active == 1" style="width: 920px; margin: 0 auto">
                    <div class="surveylink">
                        {{$t('PublishProject.InstructionsForUse')}}
                        <br />
                        {{$t('PublishProject.InstructionsForUse1')}}
                        <br />
                        {{$t('PublishProject.InstructionsForUse2')}}
                        <br />
                        {{$t('PublishProject.InstructionsForUse3')}}
                        <br />
                        {{$t('PublishProject.InstructionsForUse4')}}
                        <br />
                        {{$t('PublishProject.InstructionsForUse5')}}
                    </div>
                    <el-input type="textarea" :placeholder="$t('PublishProject.InputContent')" v-model="sub.smsContent" :show-word-limit="true" rows="10"></el-input>

                    <div class="success_btn">
                        <div>
                            <el-button size="small" type="primary" @click="backSteps()">{{$t('PublishProject.Back')}}</el-button>
                            <el-button size="small" type="primary" @click="achieve()">{{$t('PublishProject.Sending')}}</el-button>
                        </div>
                    </div>
                </div>
                <div v-if="active == 2" style="width: 920px; margin: 0 auto">
                    <div class="accomplishPage">
                        <div class="accomploshText" style="margin-top: 50px">
                            <br />
                            <el-result icon="success" :title="$t('PublishProject.SubmittedForSending')">
                            </el-result>
                        </div>
                        <div class="accomploshText" style="margin-top: 50px"></div>

                        <br />
                        <div></div>
                    </div>
                </div>
            </el-card>
        </div>
		
		<!-- 查看已发送短信   返回-->
		<div class="sent-list" v-else-if="activeShare == 2">
			<PageHeader @back="backReturn" :content="$t('PublishProject.SMSSent')" />
			<!-- <el-page-header style="padding: 20px;" @back="backReturn" :content="$t('PublishProject.SMSSent')"></el-page-header> -->
			<div class="sent-list-title">
				<el-table :data="beensent" border height="calc(100vh - 164px)">
					<el-table-column prop="smsContent" :label="$t('PublishProject.SMSContent')" width="300" align="center"></el-table-column>
					<el-table-column prop="smsNumber" :label="$t('PublishProject.NumberOfSenders')" width="180" align="center"></el-table-column>
					<el-table-column prop="sendTime" :label="$t('PublishProject.SendingTime')" align="center"></el-table-column>
					<el-table-column prop="smsState" :label="$t('PublishProject.State')" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.smsState == 1">{{$t('PublishProject.SMSDelivered')}}</span>
							<span v-else-if="scope.row.smsState == 2">{{$t('PublishProject.SMSNotDelivered')}}</span>
							<span v-else>{{$t('PublishProject.SMSDeliveryFailed')}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="auditReasons" :label="$t('PublishProject.Reason')" align="center"></el-table-column>
					<el-table-column :label="$t('PublishProject.Operate')" align="center">
						<template slot-scope="scope">
							<el-link type="primary" :underline="false" @click="seeDetail(scope.row, 1, 10)">{{$t('PublishProject.ViewDetails')}}</el-link>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!-- 查看已发送短信详情 -->
		<div class="sent-list" v-else-if="activeShare == 3">
			<PageHeader @back="backViewList" :content="$t('PublishProject.BackSentSMSList')" />
			<!-- <el-page-header style="padding: 20px;" @back="backViewList" :content="$t('PublishProject.BackSentSMSList')"></el-page-header> -->
			<div class="sent-list-title">
				<el-table :data="SmsContacts" border height="calc(100vh - 204px)">
					<el-table-column prop="cellphone" :label="$t('PublishProject.PhoneNumber')" width="300" align="center"></el-table-column>
					<el-table-column prop="name" :label="$t('PublishProject.Name')" width="180" align="center"></el-table-column>
					<el-table-column prop="result" :label="$t('PublishProject.State')" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.result == 1">{{$t('PublishProject.Success')}}</span>
							<span v-else>{{$t('PublishProject.Fail')}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="cause" :label="$t('PublishProject.Reason')" align="center">
						<template slot-scope="scope">
							<span>{{ scope.row.cause }}</span>
						</template>
					</el-table-column>
				</el-table>
				<!-- 表格分页 -->
				<div style="padding: 10px; text-align: center">
					<el-pagination
						@current-change="currentChange"
						:hide-on-single-page="false"
						:current-page.sync="one_page.currentPageIndex"
						:page-size="one_page.pageSize"
						:total="one_page.totals"
						class="fr"
						background
						layout="prev, pager, next, jumper"
					></el-pagination>
				</div>
			</div>
		</div>
		
		<!--短信发送确认模态框-->
		<el-dialog
			:title="$t('PublishProject.SendConfirmation')"
			:visible.sync="sendMask"
			width="30%">
			<div style="height: 90px">
				<p style="font-size: 16px; color: #666">{{$t('PublishProject.SMSContent')}}</p>
				<div style="padding: 5px; background: #fafafa;margin-top: 10px;">{{ sub.smsContent }}</div>
			</div>
			<div style="height: 30px; margin-top: 20px; color: #898989">
				{{$t('PublishProject.ContentContainsCharacters')}} :&nbsp;{{ sub.wordLength }}, {{$t('PublishProject.NumberOfConsumptionItems')}}：{{ sub.number }}
			</div>
			<p style="height: 30px; color: #ff3737; margin-bottom: 20px">{{$t('PublishProject.NumberOfContactsToBeSent')}}: {{ sub.smsNumber }},{{$t('PublishProject.TotalConsumptionSMSBalance')}}:{{ sub.smsNumber * sub.number }}</p>
			<p >
				{{$t('PublishProject.SMSBalance')}}:
				<span>{{ smsBalance }}</span>
				{{$t('PublishProject.Strip')}} &nbsp;
				<router-link to="/messageRecharge" target="_blank" style="color: #2672ff">{{$t('PublishProject.Recharge')}}</router-link>
			</p>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="clockSendMask">{{$t('main.cancel')}}</el-button>
				<el-button size="small" type="primary" @click="sendMask_send">{{$t('PublishProject.Sending')}}</el-button>
			</span>
		</el-dialog>
		
		<el-dialog :title="$t('main.tip')" :visible.sync="dialogWJVisible" width="20%" :close-on-click-modal="false">
			<span>{{$t('PublishProject.Wildcard')}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogWJVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="small" type="primary" @click="addWildcard">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
    </el-main>
</template>

<script>
import PageHeader from '@/components/pageHeader.vue';
export default {
    name: 'MessageShare',
	components: {
        PageHeader
    },
	data() {
		return {
			wid: this.$route.query.wid,
			active: 0,
			input2: '',
			options1: [],
			props: {
				label: 'name',
				children: 'contacts'
			},
			msgListErr: true,
			text_error: true,
			lenth: '',
			searchTell: [], //输入查找的电话
			sendMask: false, //遮罩层和发送确认
			smsBalance: '', // 短信余额
			sub: '',
			array: [], //电话联系人
			one_page: {
				// 分页
				currentPageIndex: 1, //当前第几页
				totals: 0, //总共多少条数据
				pageSize: 10 //一页显示几个
			},
			SmsContacts: [],
			activeShare: 1,
			beensent: [],
			loading: null,
			ifSel: 0,
			label: '',
			rowItem: {},
			dialogWJVisible: false,
		};
	},
	mounted() {
		this.queryContacts();
	},
	methods: {
		addWildcard() {
			this.sub.smsContent += '$[surveylink]';
			this.dialogWJVisible = false;
		},
		backViewList() {
			this.activeShare = 2
		},
		seeDetail(row, pageIndex, pageSize) {
			console.log('row', row);
			this.rowItem = row;
			this.activeShare = 3
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryQuestionsSmsSendDetails}?id=${row.id}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
				method: 'get',
				cb(res) {
					if (res.code == 0) {
						that.SmsContacts = res.resultBody.datas;
						console.log('短信分享', that.SmsContacts);
						that.one_page.currentPageIndex = res.resultBody.pageIndex;
						that.one_page.pageSize = res.resultBody.pageSize;
						that.one_page.totals = res.resultBody.total;
					} else {
						that.SmsContacts = []
						that.one_page.currentPageIndex = 1;
						that.one_page.pageSize = 10;
						that.one_page.totals = 0;
					}
				}
			};
			this.$util.request(params);
		},
		// 表格分页
		currentChange(val) {
			this.one_page.currentPageIndex = val;
			// that.searchFrom.pageIndex = val;
			this.seeDetail(this.rowItem, val, 10);
		},
		//短信返回
		backReturn() {
			this.activeShare = 1
		},
		// 关闭模态框
		clockSendMask() {
			this.sendMask = false;
		},
		// 发送提交按钮
		sendMask_send() {
			let that = this;
			console.log(that.sub.number);
			if (that.smsBalance < that.sub.number) {
				that.$message.error('短信余额不足');
				return;
			}
			let params = {
				that: this,
				url: `${this.$config.service.auditSucceed}`,
				method: 'POST',
				data: {
					id: that.sub.id,
					number: that.sub.smsNumber * that.sub.number,
					content: that.sub.smsContent
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody);
						that.active = 2;
						that.smsBalance = that.smsBalance - that.sub.number;
						if (that.smsBalance == 0) {
							that.smsBalance = 0;
						}
						that.$message.success(res.message);
						that.sendMask = false;
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		//下一步
		xiaPart() {
			let det = [];
			for (let i = 0; i < this.array.length; i++) {
				if (this.array[i].text_error == true) {
					let tempobj = {};
					tempobj.cellphone = this.array[i].cellphone;
					tempobj.name = this.array[i].name;
					tempobj.userId = this.array[i].id;
					det.push(tempobj);
				}
			}
			if (det.length <= 0) {
				this.$message.error(this.$t('PublishProject.NoContactsToSend'));
				return;
			}

			let that = this;
			that.loading = that.$loading({
				lock: true,
				text: that.$t('PublishProject.PleaseWaitAMoment'),
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			console.log('下一步', det);

			let id = that.wid;
			console.log('id', id);
			let params = {
				that: this,
				url: `${this.$config.service.addquestionssms}`,
				method: 'POST',
				data: {
					ifSave: that.ifSel,
					questionsId: id,
					saveGroup: that.label,
					smsContactsList: det
				},
				cb(res) {
					that.loading.close();
					if (res.code == 0) {
						console.log(res, '下一步成功');
						that.sub = res.resultBody;
						// that.active = 1;
						if (that.active++ > 2) this.active = 0;
					}
				}
			};
			this.$util.request(params);
		},
		msgListVerify() {
			if (this.array.length > 0) {
				let errList = this.array.filter((info) => info.text_error == false)
				this.msgListErr = errList.length > 0 ? true : false
			} else {
				this.msgListErr = true
			}
		},
		// div 富媒体 短信
		addMailCon() {
			// 获取之前输入的文本
			let that = this;

			let currentPhone = document.querySelector('#MailCon_srk').innerText.replace('，', ',');
			console.log('currentPhone', currentPhone.replace('，', ','));
			let currentPhones = currentPhone.replace(/[\r\n]/g, '').split(',');

			let reg = /^[1-9]\d{10}$/; //验证是否为手机号
			let testSpace = /^[ ]*$/g; //验证是否全都为空格
			if (testSpace.test(currentPhones[0])) {
				return false;
			} else {
				console.log('不是空格');
				if (reg.test(currentPhones[0])) {
					that.text_error = false;
				} else {
					that.text_error = true;
				}
			}
			document.querySelector('#MailCon_srk').innerText = '';
			var tempphone = {};
			tempphone.cellphone = currentPhones[0];
			tempphone.name = currentPhones.length >= 2 ? currentPhones[1] : '';
			tempphone.text_error = reg.test(currentPhones[0]);
			this.array.push(tempphone);
			that.lenth = this.array.length;
			this.msgListVerify()
			console.log('创建的联系人', that.lenth);
		},
		queryContacts() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.queryContacts}`,
				data: {},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.options1 = res.resultBody.datas;
						console.log('获取联系人列表', that.options1);
					}
				}
			};
			that.$util.request(params);
		},
		// 模糊搜索
		searchInput() {
			let that = this;
			let input2 = that.input2;
			let params = {
				that: that,
				url: `${that.$config.service.searchContacts}`,
				data: {
					search: input2
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.searchTell = res.resultBody.datas;
					}
				}
			};
			that.$util.request(params);
		},
        // 发送打开模态框按钮
		achieve() {
			let that = this;
			if (that.sub.smsContent.indexOf('$[surveylink]') == -1) {
				that.dialogWJVisible = true;
				return false;
			}
			that.sendMask = true; //打开模态框
			that.loading = that.$loading({
				lock: true,
				text:  that.$t('PublishProject.PleaseWaitAMoment'),
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let params = {
				that: this,
				url: `${this.$config.service.querySmsNumber}?type=sms`,
				method: 'GET',
				data: {},
				cb(res) {
					that.loading.close();
					if (res.code == 0) {
						// 短信余额
						that.smsBalance = res.resultBody;
						// 字符长度

						that.sub.wordLength = that.getStringWidth(that.sub.smsContent);
						// 消耗的短信条数
						let num = Math.ceil(that.sub.wordLength / 67);

						that.sub.number = num;
						console.log(that.sub);
					}
				}
			};
			this.$util.request(params);
		},
				// 计算短信内容字符串的长度
		getStringWidth(val) {
			let len = 0;
			// 对字符串中的 $[surveylink] 进行截取
			val = val.slice(1, -13);
			// 拼接问卷链接地址
			let url = window.location.origin + '/wjpc.html?id=';
			val += url;
			for (let i = 0; i < val.length; i++) {
				let length = val.charCodeAt(i);
				if (length >= 0 && length <= 128) {
					len += 1;
				} else {
					len += 2;
				}
			}
			return len + 7;
		},
        backSteps() {
			this.active = 0;
		},
		// 单删除联系人
		delMailConlxr(index) {
			let that = this;
			let array = that.array;
			// console.log(index);
			if (index > -1) {
				array.splice(index, 1);
			}
			that.lenth = this.array.length;
			this.msgListVerify()
		},
        // 全删联系人
		delContact() {
			let that = this;
			let array = that.array;
			for (let i = 0; i < array.length; i++) {
				array.splice(i);
			}
			that.lenth = this.array.length;
			this.msgListVerify()
		},
        treeBox2_a(index) {
			console.log(index);
			let that = this;
			var treephone = {};
			let reg = /^(13[0-9]|14[0-9]|15[0-9]|166|17[0-9]|18[0-9]|19[8|9])\d{8}$/;
			treephone.text_error = reg.test(that.searchTell[index].cellphone);
			treephone.cellphone = that.searchTell[index].cellphone;
			treephone.name = that.searchTell[index].name;
			that.array.push(treephone);
			console.log('that.array', that.array);
			that.lenth = that.array.length;
			this.msgListVerify()
		},
        // 左侧的添加按钮 原本的是arr11数组 改成了array 11.22
		addright(data) {
			let that = this;
			// let reg = /^1[3|4|5|8][0-9]\d{4,8}$/;
			let reg = /^(13[0-9]|14[0-9]|15[0-9]|166|17[0-9]|18[0-9]|19[8|9])\d{8}$/;
			data.text_error = reg.test(data.cellphone);
			if (data.contacts) {
				for (let i = 0; i < data.contacts.length; i++) {
					console.log(data.contacts[i]);
					data.contacts[i].text_error = reg.test(data.contacts[i].cellphone);
					this.array.push(data.contacts[i]);
				}
			} else {
				this.array.push(data);
			}

			this.array = this.unique(this.array);
			console.log('111', this.array);
			that.lenth = this.array.length;
			this.msgListVerify()
		},
		
		unique(arr) {
			const res = new Map();
			return arr.filter(arr => !res.has(arr.id) && res.set(arr.id, 1));
		},
        // 跳转联系人
		setContact() {
			this.$router.push('/contant');
		},
		//查看已发送短信
		viewShareMessage() {
			this.activeShare = 2
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.questionsSms}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res, '短信获取成功');
						that.beensent = res.resultBody.datas;
						console.log('短信分享', that.beensent);
					} else {
						that.beensent = []
					}
				}
			};
			this.$util.request(params);
		},
	},
};
</script>

<style lang="scss" scoped="scoped">
.box{
	background-color: #fff !important;
}

.message_share {
	width: 1000px;
	height: auto;
	margin: auto;
}
.message_title {
	width: 1000px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
}
.message_text {
	font-family: MicrosoftYaHei;
	font-size: 16px;
	color: #333333;
}
.view_share {
	font-family: MicrosoftYaHei;
	font-size: 14px;
	color: #0080ff;
}

.brief_introduction {
	font-size: 14px;
	color: #666;
	margin-top: 35px;
	margin-bottom: 23px;
}
.Contact_table {
	display: flex;
	justify-content: space-between;
}
.setContact {
	width: 254px;
	height: 43px;
	background-color: #f5f5f5;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.setContact .setBtn{
	cursor: pointer;
}
.setContact span {
	margin-left: 15px;
	font-size: 14px;
	color: #333;
}
.setContact i {
	color: #0080ff;
	margin-right: 20px;
}
.searchInput {
	width: 243px;
	margin: 17px auto;
}
.treeBox {
	width: 254px;
	font-size: 14px;
	height: 400px;
    overflow-y: scroll;
}
.custom-tree-node {
	width: 254px;
	position: relative;
	display: flex;
	align-items: center;
    justify-content: space-between;
}
.custom-tree-node .btn {
	color: #0080ff;
    font-size: 14px;
    cursor: pointer;
}
.treeBox2-box{
	font-size: 14px;
	height: 400px;
	overflow-y: scroll;
}

/*搜索手机号出来的div*/
.treeBox2 {
	padding: 5px 5px 5px 24px;
	display: flex;
    justify-content: space-between;
    align-items: center;
	height: 20px;
    line-height: 20px;
}
.treeBox2 .treeBox2-title{
	width: 200px;      /* 固定宽度 */
	white-space: nowrap; /* 禁止换行 */
	overflow: hidden;   /* 隐藏溢出 */
	text-overflow: ellipsis; /* 显示省略号 */
}
.treeBox2:hover {
	background: #c5e8fe;
}

.delContact i {
	margin-right: 15px;
	color: #0080ff;
}
.delContact span {
	font-size: 14px;
	color: #333;
}
.delContact {
	padding: 0 15px;
	width: 646px;
	height: 43px;
	display: flex;
	background: #f5f5f5;
	justify-content: space-between;
	align-items: center;
    box-sizing: border-box;
}
.MailCon_lxr-box{
	height: 470px;
    overflow-y: scroll;
}
#MailCon_lxr:hover {
	background: #e6eaf0;
}
/*手机号错误*/
.text_error {
	color: red !important;
}
.right {
	float: right;
}
.MailCon_srk {
	/* 取消点击框*/
	outline: none;
	height: calc(520px - 70px);
	padding: 10px 20px;
}
.surveylink {
	width: 502px;
	height: 165px;
	font-family: MicrosoftYaHei;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 28px;
	letter-spacing: 0px;
	color: #666666;
	margin-top: 55px;
}
.success_btn {
	width: 926px;
	height: 38px;
	margin-top: 19px;
	display: flex;
	justify-content: end;
	align-items: center;
	padding-bottom: 40px;
}
.accomplishPage div button {
	width: 90px;
	height: 38px;
	margin-left: 435px;
	margin-top: 30px;
	margin-bottom: 30px;
	background: #0080ff;
	color: #fff;
	border: none;
	border-radius: 3px;
}
.accomplishPage {
	width: 920px;
	display: flex;
	flex-direction: column;
}
.accomploshText p {
	font-family: MicrosoftYaHei;
	font-size: 14px;
	color: #333333;
	text-align: center;
}
</style>
